import React from 'react';

const ProductLoader = () => {
  return (
    <div className="animate-pulse">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
        {/* Image skeleton */}
        <div className="bg-gray-200 rounded-lg h-96"></div>
        
        {/* Info skeleton */}
        <div>
          <div className="h-8 bg-gray-200 rounded w-3/4 mb-4"></div>
          <div className="h-4 bg-gray-200 rounded w-1/4 mb-6"></div>
          <div className="h-6 bg-gray-200 rounded w-1/3 mb-8"></div>
          
          <div className="h-4 bg-gray-200 rounded w-1/2 mb-2"></div>
          <div className="h-24 bg-gray-200 rounded w-full mb-6"></div>
          
          <div className="h-4 bg-gray-200 rounded w-1/4 mb-2"></div>
          <div className="flex space-x-2 mb-6">
            <div className="h-8 bg-gray-200 rounded-full w-12"></div>
            <div className="h-8 bg-gray-200 rounded-full w-12"></div>
            <div className="h-8 bg-gray-200 rounded-full w-12"></div>
          </div>
          
          <div className="h-4 bg-gray-200 rounded w-1/4 mb-2"></div>
          <div className="flex space-x-2 mb-8">
            <div className="h-8 bg-gray-200 rounded-full w-12"></div>
            <div className="h-8 bg-gray-200 rounded-full w-12"></div>
            <div className="h-8 bg-gray-200 rounded-full w-12"></div>
          </div>
          
          <div className="h-12 bg-gray-200 rounded w-full"></div>
        </div>
      </div>
    </div>
  );
};

export default ProductLoader;